import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import { useState, useCallback, useEffect } from "react";
import { TopSuperIntendenciaCompaniesPerYear } from "rest/requests";
import DataTable from "examples/Tables/DataTable";
import getTableData from "./formatTableData";
import { getTopSalesSuperIntendenciaCompaniesCharts } from "./charts";
import { getExcelData } from "./getExcelData";

function TopIntendenciaCompanies() {
  const [year, setYear] = useState(2020);
  const [topCompaniesResult, setTopCompaniesResult] = useState([]);

  // ------ Year select ----------
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    setYear(value);
  };

  const [showChart, setShowChart] = useState(false);

  const getData = useCallback(async () => {
    const _topCompaniesResult = await TopSuperIntendenciaCompaniesPerYear(year);
    setTopCompaniesResult(_topCompaniesResult);
  }, [year]);

  useEffect(() => {
    getData();
  }, [year]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Ventas referenciales del mercado veterinario en el Ecuador"}
        excelData={getExcelData(topCompaniesResult)}
        excelName={"Top_Superintendencia_Companias.xlsx"}
        showChart={showChart}
        setShowChart={setShowChart}
      ></TitleCustom>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
      {showChart ? (
        getTopSalesSuperIntendenciaCompaniesCharts(topCompaniesResult, year)
      ) : (
        <DataTable table={getTableData(topCompaniesResult)} canSearch={true} />
      )}
      <MDTypography variant="overline">
        {`Valores referenciales de la página de la Superintendencia de Compañías (${year})`}
      </MDTypography>

      <Footer />
    </DashboardLayout>
  );
}

export default TopIntendenciaCompanies;
